import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ApiCalendar from 'react-google-calendar-api';

// "Not a valid origin for the client: http://localhost:3006 has not been whitelisted for client ID 
// 343984817750-oe38lh5pcnh94np4ep9i3omouelelful.apps.googleusercontent.com. 
// Please go to https://console.developers.google.com/ and whitelist this origin for your project's client ID."

import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import { actionCreators } from './action';
require('moment/locale/pl');

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
        padding: theme.spacing(0, 3),
    },
    paper: {
        maxWidth: 400,
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(2),
    },
    pomidor: {
        color: 'white',
        backgroundColor: '#D50000',
    },

}));

const message = `Truncation should be conditionally applicable on this long line of text
 as this is a much longer line than what the container can support. `;

const Calendar = (props) => {

    const events = props.events;
    const colors = {
        'default': '#3F51B5',
        '1': '#7986CB',
        '2': '#33B679',
        '3': '#8E24AA',
        '4': '#E67C73',
        '5': '#F6B726',
        '6': '#F4511E',
        '7': '#039BE5',
        '8': '#616161',
        '10': '#0B8043',
        '11': '#D50000',
    }
    
    const gapi = window.gapi;


    const CLIENT_ID = '343984817750-oe38lh5pcnh94np4ep9i3omouelelful.apps.googleusercontent.com';
    const API_KEY = 'AIzaSyAt2Utlx_oBK2AWDkcErRp0SuK8-T1JJKU';


    // Array of API discovery doc URLs for APIs used by the quickstart
    const DISCOVERY_DOCS = ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"];
    const SCOPES = "https://www.googleapis.com/auth/calendar.events";


    useEffect(() => {
        fetchEvents();
    }, []);

    const handleItemClick = (event, name) => {
        if (name === 'sign-in') {
            ApiCalendar.handleAuthClick();
        } else if (name === 'sign-out') {
            ApiCalendar.handleSignoutClick();
        }
    }

    const fetchEvents = (howMatch) => {
        props.fetchEventsGoogleCalendar();
    }

    const onlyToday = (event) => {
        const diff = moment().endOf('day').diff(moment(event.startDateTime), 'minutes');
        return (diff > 0)
    }

    const onClickHandler = () => {
        alert('test');

        gapi.load('client:auth2', () => {
            console.log('loaded client');

            gapi.client.init({
                apiKey: API_KEY,
                clientId: CLIENT_ID,
                discoveryDocs: DISCOVERY_DOCS,
                scope: SCOPES
            });

            gapi.client.load('calendar', 'v3', () => console.log('bam!'))

            gapi.auth2.getAuthInstance().then(() => {
                var event = {
                    'summary': 'Google I/O 2015',
                    'location': '800 Howard St., San Francisco, CA 94103',
                    'description': 'A chance to hear more about Google\'s developer products.',
                    'start': {
                        'dateTime': '2020-08-23T09:00:00-07:00',
                        'timeZone': 'America/Los_Angeles'
                    },
                    'end': {
                        'dateTime': '2020-08-23T17:00:00-07:00',
                        'timeZone': 'America/Los_Angeles'
                    },
                    'recurrence': [
                        'RRULE:FREQ=DAILY;COUNT=2'
                    ],
                    'attendees': [
                        { 'email': 'lpage@example.com' },
                        { 'email': 'sbrin@example.com' }
                    ],
                    'reminders': {
                        'useDefault': false,
                        'overrides': [
                            { 'method': 'email', 'minutes': 24 * 60 },
                            { 'method': 'popup', 'minutes': 10 }
                        ]
                    }
                };

                const request = gapi.client.calendar.events.insert({
                    'calendarId': 'primary',
                    'resource': event,
                })

                request.execute(event => {
                    console.log(event);
                })
            });
        })
    }

    const classes = useStyles();

    console.log('eventy', events);

    return (<>


        <div className={classes.root}>
            {events && events.filter(onlyToday).map((event) => (
                <Paper className={classes.paper}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item>
                            <Avatar  style={{backgroundColor: colors[event.colorId]}} className={classes.pomidor}>{event.summary.charAt(0)}</Avatar>
                        </Grid>
                        <Grid item xs zeroMinWidth>
                            <Typography noWrap>{moment(event.startDateTime).format('LLLL')}<br />{event.summary}</Typography>
                        </Grid>
                    </Grid>
                </Paper>
            ))}
            <button onClick={(e) => handleItemClick(e, 'sign-in')}>
                sign-in
            </button>
            <button onClick={(e) => handleItemClick(e, 'sign-out')}>
                sign-out
             </button>
            <ul>


            </ul>
            <button onClick={(e) => onClickHandler()}>laod</button>
            <button onClick={(e) => fetchEvents()}>fetch events</button>
        </div>




    </>);
}

const mapStateToProps = (state) => ({
    test: state.test, 
    events: state.googleEvents
});

export default connect(
    mapStateToProps,
    actionCreators
)(Calendar);